export default __webpack_public_path__ + "static/media/case-XC40.952de2ac.jpg";